import React, { useState } from "react"

import PortletWithSplitContent from "@/components/PortletWithSplitContent"

import { colors } from "@/styles/colors"
import useStyles from "@/pages/AccessBlockedPage/styles"

import { Button, CircularProgress, Grid, Typography } from "@material-ui/core"
import { Divider } from "@/components"

import { celcashLinks } from "@/utils/link"
import { useGlobalStateStore } from "@/store/GlobalState"

import UserInInstanceService from "@/services/UserInInstance"
import ColorUtil from "@/utils/ColorUtil"
import LetalkLogo from "@/components/SVGComponents/LetalkLogo"
import InstanceSelectorDialogue from "@/components/InstanceSelectorDialogue"
import { usePermissionStateStore } from "@/store/PermissionState"
import { PERMISSION_DENIED_MESSAGE } from "@/components/PermissionGate/BasePermissionGate"
import ManagerPanelGroupPermissionGate from "@/components/PermissionGate/ManagerPanelGroupPermissionGate"

const AccessBlockedPage: React.FC = () => {
	const [loading, setLoading] = useState(false)
	const classes = useStyles()

	const globalStateStore = useGlobalStateStore()
	const hasMultipleInstances = globalStateStore.user.user_instances.length > 1

	const { checkPermission } = usePermissionStateStore()
	const canAccessSubscriptions = checkPermission("manager-panel", "subscriptions-access")

	async function handleRedirectToRegularizedAccount () {
		setLoading(true)
		await UserInInstanceService.requestAccountRegularization()
		window.open(celcashLinks.paymentDataPage, "_blank")
		setLoading(false)
	}

	const handleOpenMultipleInstancesDialogue = () => {
		InstanceSelectorDialogue.open({
			actualUserInstanceId: globalStateStore.instance.instance_id,
			allUserInstances: globalStateStore.user.user_instances,
			isAdminView: globalStateStore?.user?.extra_data?.is_admin_mode
		})
	}

	return (
		<Grid
			container
			className={classes.container}
		>
			<Grid
				item
				className={classes.portlet}
			>
				<PortletWithSplitContent
					title={{
						value: "Acesso bloqueado",
						logo: <LetalkLogo
							className={classes.logo}
						/>,
						...ColorUtil.getBackgroundAndContrastColor(colors.red[400]),
						textColor: colors.gray[0]
					}}
					body={{
						...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
					}}
				>
					{canAccessSubscriptions ? (
						<Typography
							align="center"
							variant="subtitle1"
						>
							Clique no botão abaixo e regularize sua conta para continuar acessando a Letalk. Mas, atenção, é obrigatório usar o mesmo <strong>CNPJ</strong> e <strong>E-mail</strong> utilizados no momento da compra.
						</Typography>
					) : (
						<Typography
							align="center"
							variant="subtitle1"
						>
							Seu acesso ao sistema está temporariamente bloqueado. Para mais informações e para regularizar a situação, pedimos que entre em contato diretamente com o seu gestor. Agradecemos pela compreensão e estamos à disposição para auxiliar no que for necessário.
						</Typography>
					)}

					<Divider
						orientation="horizontal"
						size={3}
					/>

					<Grid
						container
						justifyContent="center"
						spacing={2}
					>
						<Divider
							orientation="horizontal"
							size={3}
						/>

						{hasMultipleInstances && (
							<Grid item>
								<Button
									color="primary"
									variant="outlined"
									type='submit'
									onClick={handleOpenMultipleInstancesDialogue}
									endIcon={loading && <CircularProgress size={20} color={"inherit"} />}
									disabled={loading}
									fullWidth
									style={{ height: 53 }}
								>
									Alterar instância
								</Button>
							</Grid>
						)}

						<Grid item>
							<ManagerPanelGroupPermissionGate action="subscriptions-access" tooltip={PERMISSION_DENIED_MESSAGE}>
								<Button
									color="primary"
									variant="contained"
									type='submit'
									onClick={handleRedirectToRegularizedAccount}
									endIcon={loading && <CircularProgress size={20} color={"inherit"} />}
									disabled={loading}
									fullWidth
								>
									Regularizar minha conta
								</Button>
							</ManagerPanelGroupPermissionGate>
						</Grid>
					</Grid>
				</PortletWithSplitContent>
			</Grid>
		</Grid>
	)
}

export default AccessBlockedPage
